export class Diferenciais
{
    atendeEmergencia: boolean;
    possuiEstacionamento: boolean;
    possuiAcessibilidade: boolean;
    atendimento24Horas: boolean;
    mestrado: boolean;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/resultado-pesquisa/diferenciais.ts
 **/